<div class="youtube-search-modal">
  <h2>YouTube Search</h2>
  <div class="youtube-pagination">
    <div>
      <p-inputgroup>
      <input pInputText type="text" placeholder="Search or URL" [(ngModel)]="value" (keyup.enter)="search(value, null)">
        <p-inputgroup-append>
          <button *ngIf="value" nbSuffix pButton severity="contrast" aria-label="Clear" (click)="search(value, null)">
            <i class="fas fa-search"></i>
          </button>
        </p-inputgroup-append>
      </p-inputgroup>

    </div>
    <div *ngIf="results">

      <p-button severity="info" variant="text" (click)="search(null,-1)" [disabled]="!results.prevPageToken">
        Previous Page
      </p-button>
      {{results.pageInfo.resultsPerPage * currentPage }} to {{results.pageInfo.resultsPerPage * currentPage + results.pageInfo.resultsPerPage}} of {{results.pageInfo.totalResults}}
      <p-button severity="info" variant="text" (click)="search(null,1)" [disabled]="!results.nextPageToken">
        Next Page
      </p-button>
    </div>

  </div>
  <div class="youtube-list">
    <div class="list-box" *ngIf="results">
      <div class="list-item" *ngFor="let item of results.items" (click)="setSelected(item)">
        <app-youtube-video [item]="item" [ngClass]="{'scaffold-item-selected':item===selected}"></app-youtube-video>
      </div>
    </div>
  </div>
</div>
